export enum NeoFacetTermFieldApiEnum {
    MEDIA_TYPE = 'MEDIA_TYPE',
    AD_VALUE_USD = 'AD_VALUE_USD',
    AUDIENCE_REACH = 'AUDIENCE_REACH',
    SENTIMENT = 'SENTIMENT',
    LIKE = 'LIKE',
    SHARE = 'SHARE',
    REPLY = 'REPLY',
    QUOTE = 'QUOTE',
    VIEW = 'VIEW',
    ENGAGEMENT_TOTAL = 'ENGAGEMENT_TOTAL',
    MATCHED_AGENTS = 'MATCHED_AGENTS',
    MATCHED_THEMES = 'MATCHED_THEMES',
    MENTIONS = 'MENTIONS',
    SAVE_SOURCE_TYPE = 'SAVE_SOURCE_TYPE',
    SAVING_SEARCH = 'SAVING_SEARCH',
    COUNTRY = 'COUNTRY',
    PROVINCE = 'PROVINCE',
    OUTLET_NAME = 'OUTLET_NAME',
    OUTLET_UUID = 'OUTLET_UUID',
    DOMAIN_AUTHORITY = 'DOMAIN_AUTHORITY',
    CONTACT_NAME = 'CONTACT_NAME',
    CONTACT_UUID = 'CONTACT_UUID',
    OUTLET_NAME_FACET = 'OUTLET_NAME_FACET',
    OUTLET_NAME_X_OUTLET_UUID = 'OUTLET_NAME_X_OUTLET_UUID',
    CONTACT_NAME_X_CONTACT_UUID = 'CONTACT_NAME_X_CONTACT_UUID',
    SYNDICATE_GROUP = 'SYNDICATE_GROUP',

    // LLM FACETS
    VI_BRAND_MENTIONED_TREND = 'VI_BRAND_MENTIONED_TREND',
    VI_RISK_FLAG_TREND = 'VI_RISK_FLAG_TREND',
    VI_BRAND_MENTIONED = 'VI_BRAND_MENTIONED',
    VI_RISK_FLAG = 'VI_RISK_FLAG',

    VI_BRAND_SCORE = 'VI_BRAND_SCORE',
    VI_ORGANIC_INCLUSION = 'VI_ORGANIC_INCLUSION', // visibility score
    VI_MENTION_RANK = 'VI_MENTION_RANK',
    VI_SENTIMENT_SCORE = 'VI_SENTIMENT_SCORE',
    VI_FACTUAL_ACCURACY = 'VI_FACTUAL_ACCURACY',
    VI_CITATION_COUNT = 'VI_CITATION_COUNT',
    VI_COMPETITOR_RANK = 'VI_COMPETITOR_RANK',
    VI_COMPETITOR_SENTIMENT_SCORE = 'VI_COMPETITOR_SENTIMENT_SCORE',
    VI_COMPETITOR_MENTIONED = 'VI_COMPETITOR_MENTIONED',
    VI_COMPETITOR_DOMAIN_CITED = 'VI_COMPETITOR_DOMAIN_CITED',
    VI_OWN_DOMAIN_CITED = 'VI_OWN_DOMAIN_CITED',
    AI_AGENT_ID = 'AI_AGENT_ID',
    AI_AGENT_SOURCE_ID = 'AI_AGENT_SOURCE_ID'
}
